import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PedidoNaoLiberadoCardInfoInput } from './pedido-nao-liberado-card-info.input';
import { isPedidoMotivoNaoLiberadoBonificacaoExcedente, isPedidoMotivoNaoLiberadoLucroLiquidoAbaixo, isPedidoMotivoNaoLiberadoPercDescontosMaximosItensExcedidos, isPedidoMotivoNaoLiberadoClienteInadimplente, isPedidoMotivoNaoLiberadoLimiteCreditoExcedido } from '../../domain';
import { PedidoLiberarCalculoService } from '../../services';

interface Config {
    isMotivoNaoLiberadoBonificacaoExcedente: boolean;
    isMotivoNaoLiberadoLucroLiquidoAbaixo: boolean;
    isMotivoNaoLiberadoPercDescontosMaximosItensExcedidos: boolean;
    isMotivoNaoLiberadoClienteInadimplente: boolean;
    isMotivoNaoLiberadoLimiteCreditoExcedido: boolean;
}

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info',
    templateUrl: './pedido-nao-liberado-card-info.component.html',
    styleUrls: ['./pedido-nao-liberado-card-info.component.less']
})
export class PedidoNaoLiberadoCardInfoComponent implements OnChanges {
    config?: Config;

    @Input() input?: PedidoNaoLiberadoCardInfoInput;
    percBonificacaoExcedente?: number;

    constructor(private pedidoLiberarCalculoService: PedidoLiberarCalculoService) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'input') {
                this.setConfig();
                this.calcularPercBonificacaoExcedente();
            }
        }
    }


    private setConfig() {
        this.config = {
            isMotivoNaoLiberadoBonificacaoExcedente: isPedidoMotivoNaoLiberadoBonificacaoExcedente(this.input?.motivoNaoLiberado),
            isMotivoNaoLiberadoLucroLiquidoAbaixo: isPedidoMotivoNaoLiberadoLucroLiquidoAbaixo(this.input?.motivoNaoLiberado),
            isMotivoNaoLiberadoPercDescontosMaximosItensExcedidos: isPedidoMotivoNaoLiberadoPercDescontosMaximosItensExcedidos(this.input?.motivoNaoLiberado),
            isMotivoNaoLiberadoClienteInadimplente: isPedidoMotivoNaoLiberadoClienteInadimplente(this.input?.motivoNaoLiberado),
            isMotivoNaoLiberadoLimiteCreditoExcedido: isPedidoMotivoNaoLiberadoLimiteCreditoExcedido(this.input?.motivoNaoLiberado)
        };
    }

    /** Calcula o percentual de bonificação excedente do percentual não liberado sobre o percentual máximo permitido */
    private calcularPercBonificacaoExcedente() {
        if (!this.input) {
            return;
        }
        this.percBonificacaoExcedente = this.pedidoLiberarCalculoService.calcularPercExcedenteBonificacao(this.input.percBonificacaoNaoLiberado, this.input.percBonificacaoMaximaNaoLiberado);
    }
}
